export default function Configure($stateProvider) {
    $stateProvider.state('previsionnel-tournee', {
        parent: 'gestion',
        url: '/previsionnel-tournee',
        views: {
            gestion: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.TRANSPORT" | translate }}'
        }
    });

    $stateProvider.state('previsionnel-tournee.list', {
        url: '/list',
        template: '<previsionnel-tournee></previsionnel-tournee>',
        rights: { domain: 'dmdlivrs', right: 'read' },
        ncyBreadcrumb: {
            parent: 'previsionnel-tournee',
            label: '{{ "PREVISIONNEL_TOURNEE.BREADCRUMBS.PREVISIONNEL_TOURNEE" | translate}}'
        },
        navigation: {
            menu: 'transport_plannings',
            translate: 'PREVISIONNEL_TOURNEE.BREADCRUMBS.PREVISIONNEL_TOURNEE',
            order: 14
        },
        search: 'PREVISIONNEL_TOURNEE.BREADCRUMBS.PREVISIONNEL_TOURNEE'
    });
}

Configure.$inject = ['$stateProvider'];
